exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5e602545] .van-grid-item .van-grid-item__content{background-color:hsla(0,0%,100%,0);padding:5px}.title_cell[data-v-5e602545]{padding:0 1px;background-color:transparent}", ""]);

// exports
